export default __webpack_public_path__ + "static/media/videodnk.a2d712f8.mp4";